import { Text } from '@chakra-ui/react';

import { useLogout } from '@/lib/auth';

import { ConfirmModal } from '.';

type SignOutModalProp = {
  isOpen: boolean;
  onClose: () => void;
};

export const SignOutModal = (props: SignOutModalProp) => {
  console.info('sign-out-modal.tsx_1');

  const { isOpen, onClose } = props;
  const logout = useLogout();
  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={onClose}
      title={''}
      content={<Text>{'ログアウトしますか?'}</Text>}
      primary={{
        text: 'はい',
        action: () => {
          logout.mutate({});
        },
      }}
      secondary={{
        text: 'いいえ',
        action: onClose,
      }}
      buttonColorScheme="blue"
      headerColor="white"
    />
  );
};
